import { domains } from 'config/env'

export const LICENSE_MANAGEMENT_HREF = `${domains.ADMIN_DOMAIN}/user-management`
export const MANY_USERS_DESCRIPTION_TEXT = 'Users Added'
export const SINGLE_USER_DESCRIPTION_TEXT = 'User Added'
